import { css } from '@emotion/core'

export default {
  wrapper: css`
    width: 100%;
    text-align: center;
    max-width: none;
  `,
  graphic: (width, maxWidth) => css`
    width: ${width};
    max-width: ${maxWidth};
  `,
}
